import React from "react";
import { AppBar, Toolbar, IconButton, Badge, Typography, Box, CardMedia, useTheme, } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import styles from "./styles";
import siteLogo from "@/assets/logos/Soeb-USB-symbol.svg";
var Navbar = function (_a) {
    var totalItems = _a.totalItems;
    var theme = useTheme();
    var classes = styles(theme);
    var location = useLocation();
    return (React.createElement(React.Fragment, null,
        React.createElement(AppBar, { position: "fixed", sx: classes.appBar, color: "inherit" },
            React.createElement(Toolbar, null,
                React.createElement(Typography, { component: Link, to: "/" },
                    React.createElement(CardMedia, { component: "img", src: siteLogo, alt: "Commerce.js", height: "25px", sx: classes.image })),
                React.createElement(Box, { sx: classes.grow }),
                location.pathname === "/" && (React.createElement(Box, null,
                    React.createElement(IconButton, { component: Link, to: "/cart", "aria-label": "Show cart items", color: "inherit", size: "large" },
                        React.createElement(Badge, { badgeContent: totalItems, color: "secondary" },
                            React.createElement(ShoppingCart, null)))))))));
};
export default Navbar;
